<template>
  <v-container
    id="login"
    class="fill-height justify-center"
    tag="section"
  >
    <v-row justify="center">
      <v-slide-y-transition appear>
        <base-material-card
          color="success"
          light
          max-width="100%"
          width="400"
          class="px-5 py-3"
        >
          <v-card-text class="text-center">
            <v-text-field
              v-model="email"
              color="secondary"
              label="E-Mail"
              prepend-icon="mdi-email"
              @focus="clearErrors"
            />

            <v-text-field
              v-model="password"
              class="mb-8"
              color="secondary"
              type="password"
              label="Passwort"
              prepend-icon="mdi-lock-outline"
              @focus="clearErrors"
              @keyup.enter="onLogin"
            />

            <pages-btn
              large
              color=""
              depressed
              class="v-btn--text success--text"
              @click="onLogin"
            >
              Anmelden
            </pages-btn>
          </v-card-text>
          <v-alert
            :value="hasError"
            type="error"
            data-testid="error-dialog"
          >
            {{ error }}
          </v-alert>
        </base-material-card>
      </v-slide-y-transition>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'PagesLogin',

    components: {
      PagesBtn: () => import('./components/Btn'),
    },
    data: () => ({
      email: '',
      password: '',
    }),
    computed: {
      user () {
        return this.$store.state.user.user
      },
      error () {
        return this.$store.state.user.user_error
      },
      loading () {
        return this.$store.state.user.user_request
      },
      hasError () {
        return !!this.$store.state.user.user_error
      },
    },
    watch: {
      user (newValue) {
        if (newValue) {
          this.$router.replace('/')
        }
      },
    },
    mounted () {
      this.clearErrors()
    },
    methods: {
      clearErrors () {
        if (this.error) {
          this.$store.commit('USER_CLEAR_REQUEST')
        }
      },
      onLogin () {
        this.clearErrors()
        this.$store.dispatch('USER_SIGNIN', {
          email: this.email,
          password: this.password,
        })
      },
    },
  }
</script>
